import { AUTHENTICATION_TYPES } from '@/utils/constants';

export default function () {
  return {
    loading: false,
    organization: {
      id: '',
      organizationName: '',
      totalOfficerCount: 0,
      totalUserCount: 0,
      supportRequestTotal: 0,
      lockedAccountTotal: 0,
      assigningOfficers: [],
      courses: [],
      officers: [],
      officersAssignedByUser: [],
      authenticationType: AUTHENTICATION_TYPES.PERFORMA,
      exportCompletionStatusFeatureEnabled: false,
      externalIdpSyncEnabled: false,
      externalAttributes: [],
      displayLastNameBeforeFirstName: false,
      postIdAzureAdUserPropertyName: '',
      accreditingEntityUserIdDisplayName: null,
      orgIdDisplayName: null,
      allowsAccreditationStatus: false,
      userIdFormatWebBrowserRegex: null,
      userIdFormatInstructions: null,
      showGroupNameInUserTable: false,
    },

    courses: [],
    cycles: [],
    coursesLoaded: false,
    totalUserCount: 0,

    distributionTypesSet: false,

    usage: {
      totalItems: 0,
      dailyUsage: [],
      officerUsage: [],
      officers: [],
    },

    userDetail: {
      user: null,
      assignedCourses: [],
      userDailyUsage: [],
    },

    assign: {
      courseAssignments: [],
      totalItems: 0,
      totalDistinctCourses: 0,
      totalUnfilteredItems: 0,
      hasHybridCourseAssignments: false,
    },

    allSupportRequests: [], // for a org
    supportRequests: [], // for a user

    users: [],

    officersInOrgDashboard: {
      officerList: [],
      totalItems: 0,
      totalUnfilteredItems: 0,
    },

    ssoSync: {
      syncStatus: null,
      lastSyncDate: null,
    },

    // all training officers filtered by a group and a org
    trainingOfficers: [],
    trainingOfficersLoaded: false,

    windowsDistributionType: null,

    currentQuizPolicy: {
      answerOverridesLastUpdated: null,
      answerOverrides: [],
      courseUrls: [],
      requiredCourseUrls: [],
    },

    accreditingEntities: [],
  };
}
